import { HvacArea } from '@belimo-retrofit-portal/logic';
import { ReadonlyRecord } from 'fp-ts/ReadonlyRecord';

export const HVAC_AREA_LIST: ReadonlyArray<HvacArea> = [
  HvacArea.HEATING,
  HvacArea.COOLING,
  HvacArea.VENTILATION,
];

export const HVAC_AREA_MAP: ReadonlyRecord<HvacArea, true> = {
  [HvacArea.HEATING]: true,
  [HvacArea.COOLING]: true,
  [HvacArea.VENTILATION]: true,
};
